<template>
  <div class="corporation_detail">
    <div
      v-for="headerTitle in headerTitles"
      :key="headerTitle.value"
      class="title_header"
      :style="{backgroundColor: headerTitle.color}"
    >
      <div
        class="title_header_value vertical_align_div"
        @click="pageLink(headerTitle.path)"
      >
        <span class="header_router">
          {{ headerTitle.value }}
        </span>
      </div>
    </div>
    <div class="corporation_contents">
      <div class="corporation_contents_background">
        <div class="corporation_edit_area_title">
          {{ contractEditInfoTitle }}
        </div>
        <contractInfo></contractInfo>
        <div class="corporation_edit_area_title">{{ tenantEditInfoTitle }}</div>
        <tenantInfo></tenantInfo>
        <div class="corporation_edit_area_title">
          {{ tenantOptionEditInfoTitle }}
        </div>
        <tenantOptionInfo></tenantOptionInfo>
      </div>
      <div class="corporation_bottom">
        <div class="corporation_bottom_buttons">
          <router-link to="/master/corporations">
            <input type="button" :value="cancelButton" class="cancel_button" />
          </router-link>
          <router-link to="/master/corporations/edit">
            <input type="button" :value="editButton" class="edit_button" />
          </router-link>
          <input
            type="button"
            :value="okButton"
            class="finish_button"
            @click="showMailSendModal = true"
          />
        </div>
      </div>
    </div>
    <div class="modal_window" v-if="showMailSendModal">
      <mailSendModalWindow
        :type="1"
        :tenantKey="corporation.tenantKey"
        @close="showMailSendModal = false"
      >
      </mailSendModalWindow>
    </div>
  </div>
</template>

<script>
import contractInfo from './corporationComponents/contractInfo.vue'
import tenantInfo from './corporationComponents/tenantInfo.vue'
import tenantOptionInfo from './corporationComponents/tenantOptionInfo.vue'
import mailSendModalWindow from '../modalWindow/mailSendModalWindow.vue'

export default {
  data() {
    return {
      contractEditInfoTitle: '契約情報',
      tenantEditInfoTitle: 'テナント情報',
      tenantOptionEditInfoTitle: 'テナントオプション',
      cancelButton: '一覧へ戻る',
      editButton: '編集',
      okButton: 'メール送信',
      headerTitle: '詳細',
      completeWord: '',
      failureWord: '',
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false,
      showMailSendModal: false,
      contentsHeight: '',
      contentsBackgroundHeight: ''
    }
  },
  computed: {
    headerTitles() {
      return this.$store.state.masters.detailHeaderTitle
    },
    corporation() {
      return this.$store.state.corporations.corporation
    }
  },
  created() {
    this.$store.dispatch('corporations/clearCorporation')
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    tenantInfo,
    contractInfo,
    tenantOptionInfo,
    mailSendModalWindow
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      var contaractHeight = document.getElementById('contract_info')
        .clientHeight
      var tenantHeight = document.getElementById('tenant_info').clientHeight
      var tenantOptionHeight = document.getElementById('tenant_option_info')
        .clientHeight
      var maxHeight = contaractHeight
      if (maxHeight < tenantHeight) {
        maxHeight = tenantHeight
      }
      if (maxHeight < tenantOptionHeight) {
        maxHeight = tenantOptionHeight
      }
      var height = maxHeight
      var contentsPaddingHeight = 52
      var buttonHeight = 40
      this.contentsHeight = height + contentsPaddingHeight + buttonHeight + 'px'
      this.contentsBackgroundHeight = height + 'px'
    },
    pageLink(path) {
      this.$router.push(path)
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.$router.push('/master/corporations')
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationDetail.vue